import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b ${scrolled ? 'bg-cozy-bg/80 backdrop-blur-md border-cozy-border py-3' : 'bg-transparent border-transparent py-5'}`} data-id="element-157">
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between" data-id="element-158">
        <div className="flex items-center gap-8" data-id="element-159">
          <a href="#" className="font-serif text-2xl tracking-tight text-cozy-text" data-id="element-160">
            getcozy
          </a>
          <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-cozy-muted" data-id="element-161">
            <a href="#product" className="hover:text-cozy-text transition-colors" data-id="element-162">
              Product
            </a>
            <a href="#skills" className="hover:text-cozy-text transition-colors" data-id="element-163">
              Skills
            </a>
            <a href="#pricing" className="hover:text-cozy-text transition-colors" data-id="element-164">
              Pricing
            </a>
            <a href="#docs" className="hover:text-cozy-text transition-colors" data-id="element-165">
              Docs
            </a>
          </nav>
        </div>
        <div className="flex items-center gap-4 text-sm font-medium" data-id="element-166">
          <a href="#signin" className="hidden sm:block text-cozy-muted hover:text-cozy-text transition-colors" data-id="element-167">
            Sign in
          </a>
          <a href="#start" className="bg-cozy-accent hover:bg-cozy-accentHover text-white px-4 py-2 rounded-full transition-colors shadow-sm" data-id="element-168">
            Start free
          </a>
        </div>
      </div>
    </header>;
}